import type { TalentConfigTalent } from "@/lib/talent-config-api"

export type TalentDraft = {
  description: string
  reward: string
}

export type NewTalentDraft = TalentDraft

export type TalentValidation = {
  description: string | null
  reward: string | null
}

export const validateTalentDraft = (draft: TalentDraft): TalentValidation => {
  const description = draft.description.trim()
  const reward = draft.reward.trim()

  return {
    description:
      description.length === 0
        ? "Requirement text is required."
        : description.length < 8
          ? "Requirement should be at least 8 characters."
          : null,
    reward:
      reward.length === 0
        ? "Reward text is required."
        : reward.length < 2
          ? "Reward should be at least 2 characters."
          : null,
  }
}

export const isTalentDirty = (
  draft: TalentDraft | undefined,
  talent: TalentConfigTalent,
): boolean => {
  if (!draft) return false
  return (
    draft.description !== talent.description || draft.reward !== talent.reward
  )
}
